export type TZoneType = 'MahjongSolitaire' | 'Arrows' | 'Merge2' | 'Merge3';

export interface IZoneConfigItem {
  genre: string;
  title: string;
  titleCn: string;
}

export const ZONE_CONFIG: Record<TZoneType, IZoneConfigItem> = {
  MahjongSolitaire: {
    genre: 'Mahjong Solitaire',
    title: 'Top Creatives',
    titleCn: '热门素材',
  },
  Arrows: {
    genre: 'Arrows-like',
    title: 'Top Creatives',
    titleCn: '热门素材',
  },
  Merge2: {
    genre: 'Merge-2',
    title: 'Top Creatives',
    titleCn: '热门素材',
  },
  Merge3: {
    genre: 'Merge-3',
    title: 'Top Creatives',
    titleCn: '热门素材',
  },
};

export interface IZoneGameInfo {
  game_id: string;
  genre: string;
}

export function getZoneTypeFromPath(pathname: string): TZoneType | null {
  if (pathname.includes('/MahjongSolitaire/')) return 'MahjongSolitaire';
  if (pathname.includes('/Arrows/')) return 'Arrows';
  if (pathname.includes('/Merge2/')) return 'Merge2';
  if (pathname.includes('/Merge3/')) return 'Merge3';
  return null;
}

export function getGameIdsByGenre(
  games: IZoneGameInfo[],
  genre: string,
): string[] {
  return games.filter(item => item.genre === genre).map(item => item.game_id);
}
